import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { PershingError } from '@pershing/pershing-core';
import { Warning } from '../models/warning.model';

/**
 * @desc interacts with the backend services to fetch the data and updates the data.
 */
@Injectable()
export class WarningService {
    proxyWarning$: Observable<Warning>;
    error$: Observable<PershingError>;
    private _proxyWarning: Subject<Warning>;
    private _error: BehaviorSubject<PershingError>;
    private dataStore: {
        proxyWarning: Warning;
    };
    constructor() {
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this._proxyWarning = <Subject<Warning>>new Subject();
        this.proxyWarning$ = this._proxyWarning.asObservable();
        this.dataStore = { proxyWarning: null };
    }

    insertWarning(warningMessage) {
        this.dataStore.proxyWarning = new Warning(warningMessage);
        this._proxyWarning.next(Object.assign({}, this.dataStore).proxyWarning);
    }

    setError(errorMessage: string, errorCode?: string): void {
        this._error.next(new PershingError(errorMessage, 'EMailService', errorCode));
    }

    clearError(): void {
        this._error.next(null);
    }
}
